import type { Chart } from 'chart.js';

export const getOrCreateTooltip = (chart: Chart) => {
  const parentNode = chart.canvas.parentNode;

  if (!parentNode) {
    return null;
  }

  let tooltipEl = parentNode.querySelector('div[data-tooltip="chart"]') as HTMLDivElement;

  // Create tooltip and its content if not already done
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.dataset.tooltip = 'chart';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
    tooltipEl.style.opacity = '1';
    tooltipEl.style.textAlign = 'center';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';
    tooltipEl.style.zIndex = '6';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);

    parentNode.appendChild(tooltipEl);
  }

  let verticalIndicator = parentNode.querySelector('span[data-indicator="chart"]') as HTMLSpanElement;
  // Create vertical dashed line if not already done
  if (!verticalIndicator) {
    verticalIndicator = document.createElement('span');
    verticalIndicator.dataset.indicator = 'chart';
    verticalIndicator.style.position = 'absolute';
    verticalIndicator.style.width = '1px';
    verticalIndicator.style.height = '235px';
    verticalIndicator.style.border = '1px dashed #132664';
    verticalIndicator.style.opacity = '1';
    verticalIndicator.style.pointerEvents = 'none';
    verticalIndicator.style.zIndex = '5';

    parentNode.appendChild(verticalIndicator);
  }

  return tooltipEl;
};
